import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Firebase Auth
import "./Communityprofiledescription.css";

const CommunityProfileDescription = () => {
  const [userName, setUserName] = useState("User");
  const [avatarSrc, setAvatarSrc] = useState(null);
  const description = `Welcome to the favourites section of ${userName}'s room. Explore and manage all your favourite content here.`; // Static or dynamic description

  // Fetch user data from Firebase
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserName(user.displayName || "User");
        setAvatarSrc(user.photoURL || "https://via.placeholder.com/150");
      } else {
        setUserName("User");
        setAvatarSrc("https://via.placeholder.com/150");
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <section className="communityProfile-section">
      <div className="communityProfile-container">
        <img
          src={avatarSrc} // Dynamically fetched avatar
          alt={userName}
          className="communityProfile-avatar"
        />
        <div className="communityProfile-content">
          <h1 className="communityProfile-name">{userName}</h1>
          <p className="communityProfile-description">{description}</p>
        </div>
      </div>
    </section>
  );
};

export default CommunityProfileDescription;
